import React from "react";

function AccessibilityPage() {
  return (
    <section className="jh-container jh-section">
      <h1 className="jh-title">Accessibility</h1>
      <p className="jh-sub" style={{ maxWidth: 760, margin: "0 auto" }}>
        Ridley Jewelry is committed to providing a website that is accessible to
        the widest possible audience.
      </p>

      <div style={{ maxWidth: 760, margin: "12px auto 0 auto" }}>
        <h2 className="jh-title" style={{ fontSize: 22, marginTop: 24 }}>
          Ongoing improvements
        </h2>
        <div className="jh-note" style={{ marginTop: 8 }}>
          We continuously work to improve the usability and accessibility of our
          site, including keyboard navigation, readable typography, and clear
          content structure.
        </div>

        <h2 className="jh-title" style={{ fontSize: 22, marginTop: 24 }}>
          Need assistance?
        </h2>
        <div className="jh-note" style={{ marginTop: 8 }}>
          If you have trouble using our website or would like to report an
          accessibility issue, please email support@ridleyjewelry.com and include
          the page URL and a brief description of the problem.
        </div>
      </div>
    </section>
  );
}

export default AccessibilityPage;
